import { BaseDataService, BaseUpdateComponent, ErrorHandlerService, ModalService, NotificationService, UserService } from "yt-ng-framework";
import { EPrijemnicaStavkaDodatniAtribut } from "./eprijemnica-stavka-dodatni-atribut";
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { EPrijemnicaService } from "./eprijemnica-service";

@Component({
    selector: 'yt-eprijemnica-stavka-dodatni-atribut-update',
    templateUrl: './eprijemnica-stavka-dodatni-atribut-update.component.html'
})
export class EPrijemnicaStavkaDodatniAtributUpdateComponent
    extends BaseUpdateComponent<EPrijemnicaStavkaDodatniAtribut>
    implements OnInit, OnDestroy {
    constructor(
        protected activatedRoute: ActivatedRoute,
        protected baseDataService: BaseDataService,
        protected toastrService: NotificationService,
        protected translateService: TranslateService,
        protected prijemnicaService: EPrijemnicaService,
        protected userService: UserService,
        protected changeDetectorRef: ChangeDetectorRef,
        protected modalService: ModalService,
        protected errorService: ErrorHandlerService

    ) {
        super(activatedRoute, baseDataService, toastrService, translateService, modalService);

    }

    ngOnInit() {
        super.ngOnInit();
        this.IDProcessed
            .subscribe((value) => {
                if(value){     
                    this.baseFormGroup.disable();
                    this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);
            
                }})

    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

}